import { useTranslation } from 'react-i18next';
import { Card, useRouteDocumentTitle, toNumberString } from '@client/toolkit';
import { ReportingPaths } from '../reporting.router';
import { ConsumptionCostTable } from './components/consumption-table';
import { ConsumptionGraphSection } from './components/consumption-graph';
import { ReportPageContent } from '../../../components/layout/report-page-content';
import { DashboardFiltersProvider, useDashboardFilters } from '../../dashboard/context/dashboard-filters.context';
import { DashboardFilters } from '../../dashboard/components';
import {
  EosSourcesFilter,
  EosSourcesFilterContextProvider,
  useEosSourcesFilterContext,
} from '../../../components/eos/filters/eos-sources-filter';
import { eosDateRangeFilterVisiblePresets } from '../../../components/eos/config';
import { useGetEosTotalConsumptionQuery, useGetEosTotalEnergyCostQuery } from '@client/api';
import { StatCard } from '../../../components/eos';

function EosEnergyTotalConsumptionStatCard() {
  const { t } = useTranslation('eos');
  const { sources } = useEosSourcesFilterContext();
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data } = useGetEosTotalConsumptionQuery(
    {
      sources,
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso,
    },
  );
  const { total = 0 } = data ?? {};
  return <StatCard title={t('totalConsumption')} value={`${total ? `${toNumberString(total)} kWh` : '-'}`} />;
}

function EosEnergyTotalCostStatCard() {
  const { t } = useTranslation('eos');
  const { sources } = useEosSourcesFilterContext();
  const { selectedSpaceIds, selectedDateFromIso, selectedDateToIso } = useDashboardFilters();
  const { data } = useGetEosTotalEnergyCostQuery(
    {
      sources,
      from: selectedDateFromIso || '',
      to: selectedDateToIso || '',
      spaceIds: selectedSpaceIds,
    },
    {
      skip: !selectedDateFromIso || !selectedDateToIso || sources.length === 0,
    },
  );
  const { totalEnergyCost = 0 } = data ?? {};

  return (
    <StatCard
      title={t('totalEnergyCost')}
      value={totalEnergyCost && totalEnergyCost > 0 ? `${toNumberString(totalEnergyCost)} kr` : '-'}
    />
  );
}

function EosEnergyStatsCards() {
  return (
    <div className="flex gap-5">
      <EosEnergyTotalConsumptionStatCard />
      <EosEnergyTotalCostStatCard />
    </div>
  );
}

export const ReportingEnergyCostRoute = () => {
  const { t } = useTranslation('reporting');
  useRouteDocumentTitle(t('reporting.documentTitle'), ReportingPaths.EconomyEnergyConsumption);
  return (
    <DashboardFiltersProvider dateParamsPrefix="eos">
      <EosSourcesFilterContextProvider defaultSources={['enelyze']} selectionMode="single">
        <ReportPageContent
          breadcrumb={t('energyConsumptionTitle')}
          menu={<DashboardFilters showOnlySpacesWithEosEnabled visiblePresets={eosDateRangeFilterVisiblePresets} />}
        >
          <EosSourcesFilter />
          <EosEnergyStatsCards />
          <ConsumptionGraphSection />
          <Card>
            <ConsumptionCostTable />
          </Card>
        </ReportPageContent>
      </EosSourcesFilterContextProvider>
    </DashboardFiltersProvider>
  );
};
